<template>
  <div>
    <div v-if="!bankIdResumeRequired && !bankIdResumed">
      <div v-if="!displayOnly">
        <p class="text-center">
          {{ $t('Start the BankID app on your mobile device and tap the QR code button in the app to scan the QR code on this page') }}
        </p>
        <div class="qrcode-container mb-2">
          <canvas id="qrCodeCanvas" class="qrcode-image"></canvas>
        </div>
        <div class="text-center">
          <p class="mb-2 text-center">{{ $t('or') }}</p>
          <a class="btn btn-outline-theme" :href="bankIdAppUri" v-on:click.prevent="openBankIdApp">{{ $t("Open the BankID app on this device") }}</a>
        </div>
      </div>

      <div v-if="displayOnly === 'APP'">
        <div class="text-center">
          <a class="btn btn-outline-theme" :href="bankIdAppUri" v-on:click.prevent="openBankIdApp">{{ $t("Open the BankID app on this device") }}</a>
        </div>
      </div>

      <div v-if="displayOnly === 'IMAGE_LINK' || displayOnly === 'IMAGE_B64'">
        <p class="text-center">
          {{ $t('Start the BankID app on your mobile device and tap the QR code button in the app to scan the QR code on this page') }}
        </p>
        <div class="qrcode-container mb-2">
          <img id="qrCodeImage" class="qrcode-image" :src="qrCodeImageUri">
        </div>
      </div>

      <div v-if="displayOnly === 'IMAGE_RENDER'">
        <p class="text-center">
          {{ $t('Start the BankID app on your mobile device and tap the QR code button in the app to scan the QR code on this page') }}
        </p>
        <div class="qrcode-container mb-2">
          <canvas id="qrCodeCanvas" class="qrcode-image"></canvas>
        </div>
      </div>

    </div>
    <div v-if="bankIdResumeRequired">
      <i18n tag="p" class="text-center" path="Click {0} button if you have confirmed authorization in the BankID app.">
        <span>"{{ $t('Continue authentication') }}"</span>
      </i18n>
      <div class="text-center">
        <button class="btn btn-theme" v-on:click="resumeBankId">{{ $t("Continue authentication") }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import { i18n } from '../i18n.js'
import QRCode from 'qrcode'

export default {
  name: 'BankId',
  props: {
    bankIdAppUri: {
      type: String
    },
    displayOnly: {
      type: String
    }
  },
  emits: ['BankIdAppRedirect', 'BankIdResume', 'PageHidden'],
  data() {
    return {
      bankIdResumeRequired: false,
      bankIdResumed: false,
      qrCodeImageUri: '',
      qrCodeImageData: ''
    }
  },
  methods: {
    openBankIdApp() {
      this.bankIdResumeRequired = true
      this.bankIdResumed = false
      const url = new URL(this.bankIdAppUri)
      const userAgent = navigator.userAgent
      let redirect = null
      let blank = false
      // if iOS device
      if (/iphone|ipod|ipad/i.test(userAgent)) {
        if (/fxios/i.test(userAgent)) { // Firefox
          redirect = `firefox://open-url?url=${encodeURIComponent(window.location.href)}`
        } else if (/crios/i.test(userAgent)) { // Chrome
          redirect = window.location.protocol.replace(/^http/, 'googlechrome') + '//'
        } else if (/version\//i.test(userAgent)) { // Probably Safari
          if (url.searchParams.get('redirect')) {
            window.history.replaceState({}, null, url.searchParams.get('redirect'))
          }
          redirect = window.location.href
        }
      }
      url.searchParams.set('redirect', redirect)
      this.$emit('BankIdAppRedirect', {
        blank: blank,
        redirectUri: url.href
      })
    },
    displayBankIdQrCode(bankIdAppUri) {
      if (this.displayOnly && ![
        "IMAGE_LINK",
        "IMAGE_RENDER",
        "IMAGE_B64"
      ].includes(this.displayOnly)) {
        return
      }

      let urlWithoutRedirect = bankIdAppUri
      if (bankIdAppUri.startsWith('bankid:///')) {
        const url = new URL(bankIdAppUri)
        url.searchParams.delete('redirect')
        urlWithoutRedirect = url.href
      }
      switch (this.displayOnly) {
        case 'IMAGE_B64':
        case 'IMAGE_LINK':
          this.loadImage(urlWithoutRedirect)
          break
        case 'IMAGE_RENDER':
          this.renderImage(urlWithoutRedirect)
          break
        default:
          this.loadImage(urlWithoutRedirect)
          this.renderImage(urlWithoutRedirect)
      }
    },
    renderImage(data) {
      this.$nextTick(() => {
        const qrCodeCanvas = document.getElementById('qrCodeCanvas')
        if (qrCodeCanvas === null) {
          // the element is not available
          return
        }
        qrCodeCanvas.style.display = 'block'
        QRCode.toCanvas(qrCodeCanvas, data, {}, function (err, canvas) {
          if (err) throw err
        })
      })
    },
    loadImage(link) {
      this.qrCodeImageUri = link
      this.$nextTick(() => {
        const qrCodeImage = document.getElementById('qrCodeImage')
        if (qrCodeImage === null) {
          // the element is not available
          return
        }
        qrCodeImage.style.display = 'block'
      })
    },
    resumeBankId() {
      this.bankIdResumed = true
      this.bankIdResumeRequired = false
      this.$emit('BankIdResume')
    },
    onVisibilitychange(e) {
      const lastVisibilitychange = this.lastVisibilitychange
      const currentTime = new Date().getTime()
      this.lastVisibilitychange = currentTime
      console.log(`${document.visibilityState} ${currentTime} ${currentTime - lastVisibilitychange}`)
      if (
        this.bankIdResumeRequired &&
        document.visibilityState === 'visible' &&
        (currentTime - lastVisibilitychange) > 3000
      ) {
        this.resumeBankId()
      }
      if (document.visibilityState === 'hidden') {
        this.$emit('PageHidden')
      }
    }
  },
  mounted() {
    document.addEventListener('visibilitychange', this.onVisibilitychange)
    this.displayBankIdQrCode(this.bankIdAppUri)
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.onVisibilitychange)
  },
  watch: {
    bankIdAppUri: function (oldUri, newUri) {
      if (newUri && newUri !== oldUri) {
        if (this.bankIdResumed) {
          return
        }
        this.displayBankIdQrCode(newUri)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.qrcode-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.qrcode-image {
  border: 1px solid #ccc;
  display: none;
  width: 228px;
  height: 228px;
}
</style>
